// extracted by mini-css-extract-plugin
export default {"h1":"premium-not-available-module__h1___ZwVvx","buttonWrapper":"premium-not-available-module__buttonWrapper___tyvYH","button":"premium-not-available-module__button___iz_cg"};